(function() {
    'use strict';

    angular
        .module('returnLetterApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','GLOBAL_URL'];

    function stateConfig($stateProvider,GLOBAL_URL) {
        $stateProvider.state('return-letter-uploaded', {
            url: '/return-letter-uploaded',
            data: {
                pageTitle: 'Danh sách thư trả về tải lên'
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/return-letter/return-letter-uploaded',
                    controller: 'ReturnLetterController',
                    controllerAs: 'returnLetterCtr'
                }
            }
        })
        .state('return-letter-process', {
            url: '/return-letter-process',
            data: {
                pageTitle: 'Xử lý thư trả về' 
            },
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/return-letter/return-letter-process',
                    controller: 'ReturnLetterController',
                    controllerAs: 'returnLetterCtr'
                }
            }
        })
        .state('return-letter-detail', {
            url: '/return-letter-detail/:txnId/:taskId',
            data: {
                pageTitle: 'Xử lý chi tiết thư trả về' 
            },
            params: { txnId: {squash: true, value: null }, taskId: {squash: true, value: null }},
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/return-letter/return-letter-detail',
                    controller: 'ReturnLetterDetailController',
                    controllerAs: 'detailCtr'
                }
            }
        })
        .state('return-letter-view-detail', {
            url: '/return-letter-view-detail/:txnId',
            data: {
                pageTitle: 'Xem chi tiết Xử lý chi tiết thư trả về' 
            },
            params: { txnId: {squash: true, value: null }},
            views: {
                'content@': {
                    templateUrl: GLOBAL_URL+'partial?uri=ga/return-letter/return-letter-view-detail',
                    controller: 'ReturnLetterViewDetailController',
                    controllerAs: 'detailViewCtr'
                }
            }
        })
    }
})();
